import { createSlice } from "@reduxjs/toolkit";

export const masterDataSlice = createSlice({
    name: "masterData",
    initialState: {
        userData: [],
    },

    reducers: {
        setUserData: (state, action) => {
            state.userData = action.payload;
        },
    },
});

export const { setUserData } = masterDataSlice.actions;

export default masterDataSlice.reducer;